import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsUsersByUtmQuery } from "../graphql/queries";
import type {
  AnalyticsUsersByUtmQueryType,
  AnalyticsUsersByUtmQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsUsersByUtmQuery = (
  options?: QueryHookOptions<
    AnalyticsUsersByUtmQueryType,
    AnalyticsUsersByUtmQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsUsersByUtmQueryType,
    AnalyticsUsersByUtmQueryVariablesType
  >(AnalyticsUsersByUtmQuery, options);
};
